import { Stack, ListItem, ListItemText, Typography, List, Alert } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const TurnOffAutoRenewal: React.FC = () => {
  const details = getTurnOffAutoRenewalDetails();

  return (
    <Stack
      sx={{
        justifyContent: "center",
        alignItems: "center"
      }}>
      <Stack
        direction="column"
        sx={{
          width: "594px",
          alignItems: "flex-start",
          gap: "8px",
          ml: 6
        }}>
        <Typography variant="subtitle1" sx={{
          fontWeight: 600
        }}>
          Turn off auto-renewal
        </Typography>

        <List dense disablePadding sx={{ listStyleType: 'disc', pl: 2 }}>
          {details.map((detail) => (
            <ListItem key={detail} disablePadding sx={{ py: 0.5, display: 'list-item' }}>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{
                    color: "text.primary"
                  }}>
                    {detail}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>

        <Alert
          icon={<InfoOutlinedIcon />}
          severity="info"
          sx={{
            backgroundColor: '#e7f2ff',
            color: 'text.primary',
            borderRadius: 1,
            '& .MuiAlert-icon': {
              color: 'text.primary',
            },
          }}
        >
          You can turn off auto-renew at any time before the contract ends.
        </Alert>
      </Stack>
    </Stack>
  );
};

function getTurnOffAutoRenewalDetails() {
  return ['The contract will be expired on end date', 'Expired contracts cannot be renewed or duplicated'];
}
